import fr from 'facet-rest';
import { BaseOverrideNoHidden } from 'Views/Page/Content/Templates/BaseOverride';
import { SearchableSelect } from 'Components/UI/Select/SearchableSelect';
import {
  FDCheckboxInput, FDDialogTitle,
} from '@facet-wealth/design';
import { shortDatetime } from 'Consts/DateFormats';

export default fr.metaOverride({ base: BaseOverrideNoHidden })
  .overrideAll({
    _customProps: {
      style: {
        width: '200px',
        maxWidth: '200px',
      },
      helperText: '',
    },
  }, { ordinal: 200 })
  .typeOverride('picklist', {
    _component: () => SearchableSelect,
    _customProps: {
      disabled: false,
    },
  }, { ordinal: 800 })
  .typeOverride('bool', {
    _component: () => FDCheckboxInput,
  })
  .override({ isDateTime: true }, {
    _displayTime: true,
    _formatString: shortDatetime,
  })
  .nameOverride('householdNameDisplay', {
    _component: () => FDDialogTitle,
  }, { ordinal: 200 });
